import {ITEMS_PER_PAGE} from "constants/general";

export const USER_AGENTS_ITEMS_PER_PAGE = "50";

export const userAgentsFields = {
    name: "name",
    modified: "_modified"
};

export const USER_AGENTS_FILTER_OPTIONS = {
    offset: "0",
    limit: ITEMS_PER_PAGE,
    enable_wildcards: false,
    sort_field: "_created",
    sort_direction: "desc"
};